import { Cloud, Key, Link } from "@mui/icons-material";
import { SymphonyIcon } from "@assets/icons";
import {
  isLinkOk,
  isLinkError,
  isApiError,
  isApiOk,
  isLoginError,
  isLoginOk,
} from "@common/utils/devices/summary";
import { RealTimeItemMonitoring } from "@common/components/ListDetailViews/common/RealTimeStatus/type";
import { getStatus } from "./getStatus";
import { getExtendedTooltip } from "./getExtendedTooltip";
import { GetAggregatorControllerStatusConfig } from "../types";
import { monitoringSourceLabelMap } from "../constants";

export const getAggregatorControllerStatus = ({
  device,
  lastUpdatedLabel,
  canAITroubleshoot,
  monitoringSource,
  t,
  getErrorMessage,
  onTroubleshootClick,
  tooltipAsText,
}: GetAggregatorControllerStatusConfig): RealTimeItemMonitoring[] => {
  const linkStatus = getStatus(
    isLinkOk,
    isLinkError,
    device?.aggregator,
    device?.aggregator?.status,
    canAITroubleshoot
  );

  const loginStatus = getStatus(
    isLoginOk,
    isLoginError,
    device?.aggregator,
    device?.aggregator?.status,
    canAITroubleshoot
  );

  const apiStatus = getStatus(
    isApiOk,
    isApiError,
    device?.aggregator,
    device?.aggregator?.status,
    canAITroubleshoot
  );

  const loginError = device?.aggregator?.status?.loginError || "";
  const apiError = device?.aggregator?.status?.apiError || "";

  const linkError =
    (typeof getErrorMessage === "function" &&
      getErrorMessage(monitoringSource, linkStatus)) ||
    "";

  const monitoringSourceLabel = t(monitoringSourceLabelMap[monitoringSource]);

  const linkTooltip = !tooltipAsText
    ? getExtendedTooltip(monitoringSourceLabel, lastUpdatedLabel, linkError)
    : linkError;

  const apiTooltip = getExtendedTooltip(
    monitoringSourceLabel,
    lastUpdatedLabel,
    apiError
  );

  const loginTooltip = getExtendedTooltip(
    monitoringSourceLabel,
    lastUpdatedLabel,
    loginError
  );

  const linkStatusMonitoringItem: RealTimeItemMonitoring = {
    label: "Link",
    type: linkStatus === "troubleshooting" ? "button" : "indication",
    icon: <Link />,
    status: linkStatus,
    tooltip: linkTooltip,
  };

  const loginStatusMonitoringItem: RealTimeItemMonitoring = {
    label: "Login",
    type: loginStatus === "troubleshooting" ? "button" : "indication",
    icon: <Key />,
    status: loginStatus,
    tooltip: loginTooltip,
  };

  const isSymphonyModule = device?.aggregator?.category === "AV Controllers";

  const apiStatusMonitoringItem: RealTimeItemMonitoring = {
    label: isSymphonyModule ? "Symphony Module" : "API",
    type: apiStatus === "troubleshooting" ? "button" : "indication",
    icon: isSymphonyModule ? <SymphonyIcon /> : <Cloud />,
    status: apiStatus,
    tooltip: apiTooltip,
  };

  if (typeof onTroubleshootClick === "function") {
    linkStatusMonitoringItem.onClick = () => onTroubleshootClick(linkError);
    loginStatusMonitoringItem.onClick = () => onTroubleshootClick(loginError);
    apiStatusMonitoringItem.onClick = () => onTroubleshootClick(apiError);
  }

  return [
    linkStatusMonitoringItem,
    loginStatusMonitoringItem,
    apiStatusMonitoringItem,
  ];
};
